module.exports = "./img/3c3a1db5e159513751039b4067fa64cd.jpg";